<template>
  <!--子账号-->
  <a-modal
    title="管理子账号"
    style="top: 20px;"
    :width="1200"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :footer="false"
    :maskClosable="false"
  >
    <a-form :form="form" layout="inline" style="margin-left: -30px" @keyup.enter="$refs.table3.refresh(true)">
      <a-row :gutter="24">
        <a-col :md="6" :sm="24">
          <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input v-model="queryParam.loginName" style="width: 200px;"/>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item style="margin-left: -13px;" label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input v-model="queryParam.userName" style="width: 208px;"/>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input v-model="queryParam.phone" style="width: 200px;"/>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="登录平台" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-select v-model="queryParam.isPlatform"  style="width: 180px;">
              <a-select-option value="是">
                是
              </a-select-option>
              <a-select-option value="否">
                否
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :md="6" :sm="24">
          <a-form-item label="添加人" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input v-model="queryParam.createBy" style="width: 200px;"/>
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="24">
          <a-form-item label="添加日期" :labelCol="labelCol" :wrapperCol="wrapperCol" style="width: 200px">

            <a-range-picker
              v-model="queryParam2.time2"
              :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }"
              format="YYYY-MM-DD HH:mm:ss"
              :placeholder="['开始时间', '结束时间']"
              @change="onChange1"
              @ok="onOk"
              style="width:210px"
            />
          </a-form-item>
        </a-col>

      </a-row>
      <a-row :gutter="24" style="margin: 20px 0">
        <a-col :span="16"></a-col>
        <a-col :span="8" style="text-align: right">
            <span >
              <a-button class="twobtn" type="primary" @click="$refs.table3.refresh(true)">查询</a-button>
              <a-button class="twobtn"   style="margin-left: 35px" @click="queryParam={};queryParam2={}">清空</a-button>
            </span>
        </a-col>
      </a-row>
      <a-divider/>
      <a-row :gutter="24" style="margin: 20px 0">
        <a-col :span="16"></a-col>
        <a-col :span="2" :offset="6" style="text-align: right">
            <span v-if="isShow">
              <a-button class="twobtn" v-if="addEnable" type="primary" icon="plus" @click="Subadd">新增</a-button>
            </span>
        </a-col>
      </a-row>
      <a-divider type="vertical" />
    </a-form>
    <s-table
      size="default"
      ref="table3"
      rowKey="modelId"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="installType" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installType == type.code">{{type.label}}</td>
      </span>
      <span slot="action" slot-scope="text, record">
        <span v-if="editEnable">
          <a @click="handleEdit(record.userId,record)">编辑</a>
          <a-divider type="vertical" />
          <a v-if="record.disable==1" @click="showState(record.disable,record.userId)">启用</a>
          <a v-else @click="showState(record.disable,record.userId)">禁用</a>
        </span>
        <a-divider type="vertical" v-if="editEnable && viewEnabel"/>
        <a v-if="viewEnabel" @click="handleSee(record.userId,record)">查看</a>
        <a-divider type="vertical" v-if="editEnable && deleteEnabel || deleteEnabel && viewEnabel"/>
        <a v-if="deleteEnabel" @click="deletes(record.userId,record)">删除</a>
      </span>
    </s-table>
    <submodel ref="modal" @ok="handleOk"></submodel>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
import { queryMaster} from '@/api/master/MasterList'
import { SubAccount,teamRoleAll,disable,SubAccountopen,SubAccountdelete,Subupdate,SubAccountget } from '@/api/master/TeamManagement'
import Submodel from './Submodel.vue'
import moment from 'moment'
import store from '@/store'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'SubAccount',
  components: {
    STable,
    Submodel
  },
  data () {
    return {
      addEnable: checkPermission('master:teamList:childAccount:add'),
      editEnable:checkPermission('master:teamList:childAccount:edit'),
      deleteEnabel: checkPermission('master:teamList:childAccount:delete'),
      viewEnabel: checkPermission('master:teamList:childAccount:view'),
      form: this.$form.createForm(this),
      createBy: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      confirmLoading: false,
      queryParam: {},
      queryParam2:{},
      data:[],
      pagination: false,
      loading: false,
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          width: '20px',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'disable',
          width: '20px',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '姓名',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '联系方式',
          dataIndex: 'phone',
          align: 'center'
        },
        {
          title: '登录平台',
          dataIndex: 'isPlatform',
          align: 'center'
        },
        {
          title: '添加日期',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '添加人',
          dataIndex: 'createBy',
          align: 'center'
        }
      ],
      teamId: '',
      isShow:false,
      loadData: parameter => {
        this.queryParam.teamId = this.teamId
        return SubAccount(Object.assign(parameter, this.queryParam))
      },
      Roledata:'',
    }
  },
  destroyed () {
    this.$nextTick(()=>{
      document.body.removeEventListener('keyup', e => {})
    })
  },
  created () {
    // console.log(store.getters.workType)
    if(store.getters.workType == 6){
      this.isShow = true
    }else{
      this.isShow = false
    }
    this.$nextTick(()=>{
      document.body.addEventListener('keyup', e => {
        if (e.keyCode == 13) {
          this.$refs.table3.refresh(true)
        }
      })
    })
  },
  methods:{
    moment,
    handleSee (id, val) {
      this.$refs.modal.add(id, val, 1,this.Roledata)
    },
    handleEdit (id, val) {
      this.$refs.modal.add(id, val, 0,this.Roledata)
    },
    deletes (id, val) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          let ids = that.qs.stringify({ id })
          SubAccountdelete(ids).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.$refs.table3.refresh(true)
            } else {
              that.$message.error(res.msg)
            }
          })
        },
      });
    },
    showState (dis,userid) {
      console.log(userid)
      let id = userid
      let idl = this.qs.stringify({id})
      console.log(idl)
      if (dis == '1') {
        SubAccountopen(idl).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.$refs.table3.refresh(true)
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (dis == '0') {
        disable(idl).then(res => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.$refs.table3.refresh(true)
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    onChange1 (date, dateString) {
      this.queryParam.startTime=dateString[0]
      this.queryParam.endTime=dateString[1]
    },
    add (id) {
      teamRoleAll({teamId:id}).then(res=>{
        this.Roledata=res.rows
      })
      this.teamId = id
      this.visible = true
      this.$refs.table3.refresh(true)
    },
    Subadd () {
      console.log(this.teamId,'this.teamIdthis.teamId')
      this.$refs.modal.add(this.teamId, 0, 2,this.Roledata)
    },
    handleOk () {
      this.$refs.table3.refresh(true)
    }
  }
}
</script>

<style scoped>
  .ant-row{
    margin-top: 10px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px;}
</style>
